export default {
  setLoading(state, payload) {
    state.loading = payload;
  },

  setCurrentUser(state, payload) {
    state.currentUser = payload;
  },

  setBanner(state, payload) {
    state.banner = payload;
  },

  setNotifications(state, payload) {
    state.notifications = payload;
  },

  setShowSsoSyncBanner(state, payload) {
    state.showSsoSyncBanner = payload;
  },

  setRedemption(state, payload) {
    state.redemption = payload;
  },

  setOfflineStatus(state, payload) {
    state.offlineStatus = payload;
  },

  setBannerMessages(state, payload) {
    state.bannerMessages = payload;
  },

  dismissBannerMessage(state) {
    state.bannerMessages.shift();
  },

  setMarketingMessages(state, payload) {
    state.marketingMesssages = payload;
  },

  dismissMarketingMessages(state) {
    state.marketingMesssages.shift();
  },
};
